// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NcD5","input":"styles_input__7Dhb-"};